"use client"

import { faFacebookF, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Link from "next/link"

interface SocialSectionProps {
  className?: string
  facebookUrl?: string
  twitterUrl?: string
  youtubeUrl?: string
}

export const SocialSection: React.FC<SocialSectionProps> = ({
  className = "",
  facebookUrl,
  twitterUrl,
  youtubeUrl,
}) => {
  return (
    <div
      className={`flex sm:gap-5 gap-2.5 justify-center sm:justify-start sm:pt-0 sm:pb-0 pt-5 pb-[30px] ${className}`}
    >
      {facebookUrl && (
        <Link
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center text-white hover:bg-[#4267b2] transition duration-300"
        >
          <FontAwesomeIcon icon={faFacebookF} className="text-white w-[14px] h-[14px]" />
        </Link>
      )}
      {youtubeUrl && (
        <Link
          href={youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center text-white hover:bg-[#FF0000] transition duration-300"
        >
          <FontAwesomeIcon icon={faYoutube} className="text-white w-[14px] h-[14px]" />
        </Link>
      )}
      {twitterUrl && (
        <Link
          href={twitterUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center text-white hover:bg-[#fcaf45] transition duration-300"
        >
          <FontAwesomeIcon icon={faTwitter} className="text-white w-[14px] h-[14px]" />
        </Link>
      )}
    </div>
  )
}
